<div class="modal fade" id="kt_modal_view_bl_form" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">Letter of Guarantee - Amendment {{ amendmentNumber }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body p-5" *ngIf="blForm && order">
        <!-- Letter of Guarantee Content -->
        <div class="letter-of-guarantee">
          <!-- Header Section -->
          <div class="log-header d-flex justify-content-between align-items-start mb-4">
            <div class="logo-section d-flex align-items-center">
              <div class="logo-circle me-3">
                <span class="logo-text">ISL</span>
              </div>
              <div class="company-tagline">
                <strong class="text-primary">Imperial</strong><br>
                <strong class="text-primary">Solutions</strong><br>
                <small class="text-muted fst-italic">PROSPERITY FOR ALL</small>
              </div>
            </div>
            <div class="company-details text-end">
              <h6 class="fw-bold mb-1">IMPERIAL SOLUTIONS LTD.</h6>
              <p class="mb-0 small">22-14 AOBADAI,</p>
              <p class="mb-0 small">KITA-KU, JAPAN</p>
              <p class="mb-0 small">Tel: +81-78-291-5360 Fax: +81-78-291-5374</p>
              <p class="mb-0 small">E-mail: ISL&#64;IMPERIALSOLUTIONS.JP</p>
            </div>
          </div>

          <!-- Date -->
          <p class="mb-3">{{ getCurrentDate() }}</p>

          <!-- Title -->
          <h3 class="text-center fw-bold mb-4">LETTER OF GUARANTEE</h3>

          <!-- Order Details -->
          <div class="order-details mb-4">
            <table class="table table-sm table-borderless">
              <tbody>
                <tr>
                  <td class="fw-bold" style="width: 150px;">Stock Number:</td>
                  <td>{{ getStockNumber() }}</td>
                </tr>
                <tr>
                  <td class="fw-bold">VSL/VOY:</td>
                  <td>{{ getVslVoy() }}</td>
                </tr>
                <tr>
                  <td class="fw-bold">Port of Loading:</td>
                  <td>{{ getPortOfLoading() }}</td>
                </tr>
                <tr>
                  <td class="fw-bold">Port Of Discharge:</td>
                  <td>{{ getPortOfDischarge() }}</td>
                </tr>
                <tr *ngIf="hasShipperAmendment()">
                  <td class="fw-bold">Shipper:</td>
                  <td>{{ amendment?.shipper_company || '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- BL Number - Editable -->
          <div class="d-flex align-items-center justify-content-center mb-4">
            <strong class="me-2">BL No:</strong>
            <input
              type="text"
              class="form-control form-control-sm"
              style="width: 200px;"
              [ngModel]="blNo"
              (ngModelChange)="onBlNoChange($event)"
              placeholder="Enter BL No" />
            <button
              *ngIf="blNoChanged"
              type="button"
              class="btn btn-sm btn-primary ms-2"
              [disabled]="isSavingBlNo"
              (click)="saveBlNo()">
              <span *ngIf="!isSavingBlNo">Save</span>
              <span *ngIf="isSavingBlNo" class="spinner-border spinner-border-sm"></span>
            </button>
          </div>

          <!-- Reason for Amendment -->
          <div class="reason-section mb-4">
            <p class="fst-italic text-primary mb-1">REASON FOR AMENDMENT:</p>
            <p class="fst-italic text-primary mb-2">WITH REFERENCE TO THE ABOVE MENTIONED BILL(S) OF LADING, WE WOULD REQUEST YOU AMEND AS FOLLOWS:-</p>
            <p class="text-center fw-bold">PLEASE AMEND CONSIGNEE AND NOTIFY AS FOLLOWS</p>
          </div>

          <!-- Comparison Section -->
          <div class="comparison-section" *ngIf="hasAnyAmendment()">
            <div class="row">
              <!-- Original Column -->
              <div class="col-6">
                <div class="original-header bg-primary text-white text-center py-2 fw-bold mb-2">
                  ORIGINAL
                </div>
              </div>
              <!-- Amendment Column -->
              <div class="col-6">
                <div class="amendment-header bg-info text-white text-center py-2 fw-bold mb-2">
                  AMMENDMANT NEEDED
                </div>
              </div>
            </div>

            <!-- Consignee Section -->
            <div class="row mb-3" *ngIf="hasConsigneeAmendment()">
              <div class="col-6">
                <div class="info-box border p-2">
                  <div class="info-header bg-light text-center py-1 fw-bold mb-2 border-bottom">
                    ORIGINAL CONSIGNEE INFO
                  </div>
                  <div class="info-content">
                    <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getOriginalConsigneeInfo() }}</pre>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-box border p-2">
                  <div class="info-header bg-info bg-opacity-25 text-center py-1 fw-bold mb-2 border-bottom text-info">
                    TO BE AMENDED CONSIGNEE INFO
                  </div>
                  <div class="info-content text-info">
                    <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getAmendmentConsigneeInfo() }}</pre>
                  </div>
                </div>
              </div>
            </div>

            <!-- Notify Party Section -->
            <div class="row mb-3" *ngIf="hasNotifyPartyAmendment()">
              <div class="col-6">
                <div class="info-box border p-2">
                  <div class="info-header bg-light text-center py-1 fw-bold mb-2 border-bottom">
                    ORIGINAL NOTIFY PARTY INFO
                  </div>
                  <div class="info-content">
                    <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getOriginalNotifyPartyInfo() }}</pre>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-box border p-2">
                  <div class="info-header bg-info bg-opacity-25 text-center py-1 fw-bold mb-2 border-bottom text-info">
                    TO BE AMENDED NOTIFY PARTY INFO
                  </div>
                  <div class="info-content text-info">
                    <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getAmendmentNotifyPartyInfo() }}</pre>
                  </div>
                </div>
              </div>
            </div>

            <!-- Shipper Section -->
            <div class="row mb-3" *ngIf="hasShipperAmendment()">
              <div class="col-6">
                <div class="info-box border p-2">
                  <div class="info-header bg-light text-center py-1 fw-bold mb-2 border-bottom">
                    ORIGINAL SHIPPER INFO
                  </div>
                  <div class="info-content">
                    <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getOriginalShipperInfo() }}</pre>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-box border p-2">
                  <div class="info-header bg-info bg-opacity-25 text-center py-1 fw-bold mb-2 border-bottom text-info">
                    TO BE AMENDED SHIPPER INFO
                  </div>
                  <div class="info-content text-info">
                    <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getAmendmentShipperInfo() }}</pre>
                  </div>
                </div>
              </div>
            </div>

            <!-- Vehicle Sections - Dynamic -->
            <ng-container *ngFor="let vehicle of order?.vehicles; let i = index">
              <div class="row mb-3" *ngIf="hasVehicleAmendment(i)">
                <div class="col-6">
                  <div class="info-box border p-2">
                    <div class="info-header bg-light text-center py-1 fw-bold mb-2 border-bottom">
                      ORIGINAL VEHICLE {{ i + 1 }} INFO
                    </div>
                    <div class="info-content">
                      <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getOriginalVehicleInfo(i) }}</pre>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="info-box border p-2">
                    <div class="info-header bg-info bg-opacity-25 text-center py-1 fw-bold mb-2 border-bottom text-info">
                      TO BE AMENDED VEHICLE {{ i + 1 }} INFO
                    </div>
                    <div class="info-content text-info">
                      <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getAmendmentVehicleInfo(i) }}</pre>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- Shipping Details Section -->
            <div class="row mb-3" *ngIf="hasShippingDetailsAmendment()">
              <div class="col-6">
                <div class="info-box border p-2">
                  <div class="info-header bg-light text-center py-1 fw-bold mb-2 border-bottom">
                    ORIGINAL SHIPPING DETAILS
                  </div>
                  <div class="info-content">
                    <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getOriginalShippingDetails() }}</pre>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="info-box border p-2">
                  <div class="info-header bg-info bg-opacity-25 text-center py-1 fw-bold mb-2 border-bottom text-info">
                    TO BE AMENDED SHIPPING DETAILS
                  </div>
                  <div class="info-content text-info">
                    <pre class="mb-0 small" style="white-space: pre-wrap; font-family: inherit;">{{ getAmendmentShippingDetails() }}</pre>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Undertaking Statement -->
          <div class="undertaking-section mt-4 mb-4">
            <p class="text-primary fst-italic small">
              WE, THE UNDERSIGNED, DO HEREBY UNDERTAKE TO HOLD YOU FREE AND HARMLESS FROM ANY CLAIM THAT MAY
              ARISE IN CONNECTION WITH THE ABOVEMENTIONED AMENDMENT(S) AND TO INDEMNIFY YOU AGAINST ALL CONSEQUENCES
              OF YOU SO DOING.
            </p>
          </div>

          <!-- Signature Section -->
          <div class="signature-section d-flex justify-content-end mt-5">
            <div class="text-center">
              <div class="stamp-box mb-2 p-2 border" style="width: 100px; height: 80px;">
                <div class="stamp-content text-muted small">
                  <span style="font-size: 10px;">株式会社</span><br>
                  <strong class="text-danger">IMPERIAL<br>SOLUTIONS</strong>
                </div>
              </div>
              <div class="signature-line border-top pt-2">
                <p class="mb-0 small">Yours faithfully,</p>
                <p class="mb-0 fst-italic"><strong>Imperial Solutions</strong></p>
                <p class="mb-0">D.S.SETHI</p>
                <p class="mb-0 fw-bold">IMPERIAL SOLUTIONS LTD</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        <button
          type="button"
          class="btn btn-primary me-2"
          *ngIf="pdfUrl"
          (click)="openPdf()">
          <i class="ki-duotone ki-eye fs-2 me-1">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </i>
          View PDF
        </button>
        <button
          type="button"
          class="btn btn-success me-2"
          [disabled]="excelImporting"
          (click)="exportToExcel()">
          <i class="ki-duotone ki-file-up fs-2 me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          {{ excelImporting ? 'Exporting...' : 'Export Excel' }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          (click)="generatePdf()"
          [disabled]="isGeneratingPdf">
          <span *ngIf="isGeneratingPdf" class="spinner-border spinner-border-sm me-2"></span>
          <i *ngIf="!isGeneratingPdf" class="ki-duotone ki-file-down fs-2 me-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
          {{ isGeneratingPdf ? 'Generating' : 'Generate PDF' }}
        </button>
      </div>
    </div>
  </div>
</div>
